import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

const ajax = axios.create({
  timeout: 15000 // 请求超时时间
})

// const prefix = process.env.NODE_ENV === 'development' ? '' : 'http://beta-tus.waddles.club'

ajax.interceptors.request.use(config => {
  // config.url = prefix + config.url
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  return config
}, error => {
  return Promise.reject(error)
})

ajax.interceptors.response.use(response => {
  if (response.status === 200) {
    const { code, error, size } = response.data
    if (code === 1 || error === 0 || size) {
      return response.data
    } else if (response.data.msg === '请先登录') {
      router.push('/login')
      Message.error(response.data.msg)
    } else {
      Message.error(response.data.msg)
    }
  }
}, error => {
  return Promise.reject(error)
})

ajax.downloadFile = (url, params) => {
  return ajax({
    method: 'post',
    url,
    data: params,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    responseType: 'blob'
  }).then(res => {
    const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      const href = URL.createObjectURL(blob)
      elink.download = '下载'
      elink.style.display = 'none'
      elink.href = href
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, '下载')
    }
  }).catch(error => {
    return Promise.reject(error)
  })
}

export default ajax
